const merge = require('lodash/merge');
const { apiPortfolioId } = require('../../utils');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');

function apiFactory({
  baseUrl,
  requestHandler
}) {
  const headers = {
    Accept: 'application/json'
  };

function getUrl(endpoint) {
  return `${baseUrl}${endpoint}`;
}

return {

  checkUserType(metaData) {
      const url = getUrl('user-rmia-details');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST'
      };

       
      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: parsedMetaData.portfolio.branchCode
      };

      return requestHandler(merge(reqOpts, {
        url,
        body,
        json:true,
      }));
    },

    
   getResponseJson(portfolioId, deviceType, starRating, feedbackCateg,feedbackText,logoutTriggered,clientAdvisorFlag,metaData) {
     
      const url = getUrl('submit-feedback');

      let feedbackCateg_value = "";
      let feedbackText_Finalvalue ="";
      
      let feedbackText_value= feedbackText.replace(/-/g, ' ');
      const clientAdvisorFlag_value = clientAdvisorFlag.replace(/-/g, ' ');

      if(starRating==0)
      {
        feedbackCateg_value = feedbackCateg.replace(/-/g, ' ');
        feedbackText_Finalvalue=feedbackText_value.replace(/feedbackText/gi,'').toString();
      }
      else
      {
         feedbackCateg_value = null;
         feedbackText_Finalvalue= null;
      }
      
      

      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST'
      };
      
      const body = {
        pfId: parsedMetaData.portfolio.pfRelId,
        userId: parsedMetaData.qs.userId,
        deviceType: deviceType,
        clientAdvisorFlag:clientAdvisorFlag_value,
        starRating: starRating,
        feedbackCateg:feedbackCateg_value,
        feedbackText:feedbackText_Finalvalue,
        logoutTriggered:logoutTriggered
      };

      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
      }));

    },

  getStarFeedback(portfolioId, deviceType, starRating, feedbackCateg,feedbackText,logoutTriggered,clientAdvisorFlag,metaData) {
     
      const url = getUrl('submit-star-feedback');

      let feedbackCateg_value = "";
      let feedbackText_Finalvalue ="";
      
      let feedbackText_value= feedbackText.replace(/-/g, ' ');
      const clientAdvisorFlag_value = clientAdvisorFlag.replace(/-/g, ' ');

      if(starRating==0)
      {
        feedbackCateg_value = feedbackCateg.replace(/-/g, ' ');
        feedbackText_Finalvalue=feedbackText_value.replace(/feedbackText/gi,'').toString();
      }
      else
      {
         feedbackCateg_value = null;
         feedbackText_Finalvalue= null;
      }
      
      

      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST'
      };
      
      const body = {
        pfId: parsedMetaData.portfolio.pfRelId,
        userId: parsedMetaData.qs.userId,
        deviceType: deviceType,
        clientAdvisorFlag:clientAdvisorFlag_value,
        starRating: starRating,
        feedbackCateg:feedbackCateg_value,
        feedbackText:feedbackText_Finalvalue,
        logoutTriggered:logoutTriggered
      };

      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
      }));

    },

  checkStarFeedback(metaData) {
     const url = getUrl('show-star-feedback');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST'
      };

       
      const body = {
        userId: parsedMetaData.qs.userId
      };

    return requestHandler(merge(reqOpts, {
      url,
      body,
      json:true,
    }));
  }
};
}

module.exports = apiFactory;

